import { AppReducers } from "./AppReducers";
import { ApplicationReducers } from "./ApplicationsReducers";
import { CCReducers } from "./CCReducers";
import { CUReducers } from "./CUReducers";
import { LLReducers } from "./LLReducers";
import { OrgnizationReducers } from "./OrganizationReducers";
import { UserReducers } from "./UserReducers";
import { globalServiceCenterReducer } from "./globalServiceCenterReducer";

const appReducer: any = {
  user: UserReducers,
  organization: OrgnizationReducers,
  app: AppReducers,
  application: ApplicationReducers,
  CCData: CCReducers,
  CUData: CUReducers,
  LLData: LLReducers,
  globalServiceCenter: globalServiceCenterReducer,
};

export default appReducer;
